import React from "react";
import { Stack, Typography } from "@mui/material";

interface IconValueVisualInterface {
  icon: string;
  value: string;
  iconColor?: string;
  iconSize?: "sm" | "md" | "lg";
}

const IconValueVisual = ({
  icon,
  value,
  iconColor = "green",
  iconSize = "md",
}: IconValueVisualInterface) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <i className={`${icon} font-${iconColor} icon-${iconSize}`}></i>
      <Typography variant="h5" fontWeight={400}>
        {value}
      </Typography>
    </Stack>
  );
};
export default IconValueVisual;
